import React from 'react';

import _ from 'lodash';

import { Error, StyledInput, StyledInputLoading, StyledLabel, StyledSubtext } from './styles';
import { type InputProps } from './types';

const Input: React.FC<InputProps> = React.forwardRef(({ errorMessage, helperText, id, isLoading, ...props }, ref) => {
    const identifier = id ?? _.uniqueId(`${props.name}_`);

    const renderSubtext = () => {
        if (errorMessage) {
            return <Error>{errorMessage}</Error>;
        }

        if (helperText) {
            return <StyledSubtext id={`helper_${identifier}`}>{helperText}</StyledSubtext>;
        }

        return null;
    };

    const helperTextAttributes = helperText ? { 'aria-describedby': `helper_${identifier}` } : {};

    // Add aria-labelledby for the label and potential error messages
    const labelledBy = props.label ? `label_${identifier}` : '';
    const errorAria = errorMessage ? ` error_${identifier}` : '';
    const ariaLabelledBy = `${labelledBy}${errorAria}`.trim();

    return (
        <>
            {props.label && (
                <StyledLabel id={`label_${identifier}`} htmlFor={identifier} isRequired={props.required}>
                    {props.label}
                </StyledLabel>
            )}
            {isLoading ? (
                <StyledInputLoading />
            ) : (
                <StyledInput
                    id={identifier}
                    inputRef={ref}
                    error={!!errorMessage}
                    aria-invalid={!!errorMessage}
                    aria-labelledby={ariaLabelledBy}
                    {...props}
                    {...helperTextAttributes}
                />
            )}
            {renderSubtext()}
        </>
    );
});

export default Input;
